export default function () {
  return {
    prevRoute: {},
    currentRoute: {},
    breadcrumbs: [],
    breadcrumbParams: {},
    sidebarPin: true
  }
}
